const lol = /🖕JS_DS🚀/.source
export const DSP = lol.slice(0, 5)
export const DSS = lol.slice(4)
export const DATASTAR_FETCH_EVENT = 'datastar-fetch'
export const DATASTAR_SIGNAL_PATCH_EVENT = 'datastar-signal-patch'
